
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/learn/about-us",
      function () {
        return require("private-next-pages/learn/about-us/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/learn/about-us"])
      });
    }
  